import React, {useEffect, useRef, useState} from "react";
import { AddressSuggestions } from "react-dadata";
import { useFieldArray, useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import request, {getUrl, requestSvg} from "../../api";
import useMedia from '../../hooks/useMedia';
import { validateMail } from "../../utils";
import {PenIcon, TelegramIcon, WhatsupIcon} from "../Public/markup/icons";
import Requisites from "../Requisites";
import Checkbox from '../core/Checkbox';
import Wrap from '../core/ModalWrap';
import Popup from '../core/Popup';
import { errorToast } from '../toasts';
import ChangePassword from "./ChangePassword";
import "react-dadata/dist/react-dadata.css";
import statusStub from "../../assets/images/status-stub.png";
import statusChart from "../../assets/images/statusStub.svg";
import tgqr from "../../pages/PersonalProfile/tgqr.png";
import useApi from "../../hooks/useApi";
import SubmitButton from "../SubmitButton";
import classNames from "classnames";
import Button from "../core/Button";
import {useModal} from "react-modal-hook";
import PanModal from "../core/PanModal";
import ErrorReport from "../Apartment/NewAppartment/errorReport";

const phoneRequired = (v) =>
  v && v.indexOf("_") === -1 ? undefined : "Введите телефон";

const Input = (props) => {
  const { name, inputRef, value, ...rest } = props;
  return (
    <InputMask {...rest} mask="+7 (999) 999-99-99" maskChar="_">
      {(inputProps) => (
        <input value={value} name={name} ref={inputRef} {...inputProps} />
      )}
    </InputMask>
  );
};

const accessData = {
  general: {
    name: "Генеральный директор",
    description:
      "Имеет доступ к базе, комиссионному вознаграждению, может добавлять сотрудников.",
  },
  master: {
    name: "Мастер-аккаунт",
    description:
      "Имеет доступ к базе, комиссионному вознаграждению, может добавлять сотрудников.",
  },
  "agent_extended": {
    name: "Агент расширенным доступом",
    description: "Имеет доступ к базе и комиссионному вознаграждению.",
  },
  agent: {
    name: "Агент",
    description:
      "Имеет доступ к базе. Не видит комиссионное вознаграждение.",
  },
}

const Form = (props) => {

  const userAccess = useSelector(state=>state.user.access);

  const isMobile = useMedia("isMobile");

  const {
    edit,
    editPassword,
    defaultValues,
    canEditAgency,
    profile,
    settings,
    setSettings,
    tgSettings,
    setEmailSettings,
    emailSettings,
    setTgSettings,
    pushSettings,
    setPushSettings,
    requisitesData = {},
    refreshRequisites,
    showRequisites,
    isUpdating,
    isEmployee
  } = props;
  const accessInfo = accessData[userAccess]
  const { manager } = profile;
  const { requisites, bankRequisites, companyId } = requisitesData;
  const { handleSubmit, register, errors, control, setValue} = useForm({
    defaultValues,
  });
  const cityRef = useRef(null);

  const [city, setCity] = useState({value: defaultValues.cityName});
  // const [logo, setLogo] = useState(
  //   defaultValues.workLogo ? getUrl(defaultValues.workLogo.src): null,
  // );
  const [logo, setLogo] = useState(
    defaultValues?.photo ? getUrl(defaultValues?.photo.src): null,
  );
  const [logoFile, setLogoFile] = useState(null);


  const onSubmit = (values) => {
    if (values.telegram && values.telegram.trim() !== '' && values.telegram[0] !== '@') {
      values.telegram = `@${values.telegram}`;
    }

    if(!city?.value && canEditAgency) return errorToast("Введите корректный город")
    if (canEditAgency) {
      values.cityName = city ? city.value : defaultValues.cityName;
      if (logoFile) {
        values.workLogo = logoFile;
      }
    }

    if (logoFile) {
      values.photo = logoFile;
    }

    edit(values);

  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "phone",
  });

  const {
    fields: fieldsEmail,
    append: appendEmail,
    remove: removeEmail,
  } = useFieldArray({
    control,
    name: "email",
  });

  const getTitle = () => {
    let title = `${profile.lastName ? profile.lastName: ""} ${profile.name? profile.name: ""}`;
    if (profile.patronymic) title += ` ${profile.patronymic.charAt(0)}.`;
    return title;
  };

  const changeFile = (e) => {
    const tmpFiles = e.target.files[0];
    setLogoFile(tmpFiles);
    var reader = new FileReader();
    var url = reader.readAsDataURL(tmpFiles);

    reader.onloadend = function (e) {
      setLogo(reader.result);
    };
  };

  const handleCityBlur = (ref) => {
    if (ref.current.state.suggestions.length > 0) {
      if (
        ref.current.state.inputQuery !==
        ref.current.state.suggestions[0].data.city
      ) {
        ref.current.selectSuggestion(0);
      }
    }
  };


  const [validValue, setValidValue] = useState("")
  const telegramInputFocus = (e) => {
    if (e.target.value) {
      return
    }
    setValidValue("@")
    setValue(`telegram`, "@")
  }
  const telegramBlur = (e)=> {
    if (e.target.value === "@") {
      setValidValue("")
      setValue(`telegram`, "")
    }
  }
  const setTelegramValue = (e) => {
    let val = e.currentTarget.value
    if(val && val[0] !== "@"){
      val = `@${val}`
    }

    // Update the value in the form
    setValidValue(val)
    setValue(`telegram`, val)
  }


  const [notificationSettings, setNotificationSettings] = useState({
    telegram: {},
    email: {},
    push: {}
  });

  useEffect(() => {
    if (tgSettings) {
      const telegramSettings = {};
      Object.entries(tgSettings).forEach(([key, value]) => {
        if (typeof value === "boolean") {
          telegramSettings[key] = value;
        }
      });
      setNotificationSettings(prev => ({
        ...prev,
        telegram: telegramSettings
      }));
    }
    if (emailSettings) {
      const emailSettingsObj = {};
      Object.entries(emailSettings).forEach(([key, value]) => {
        if (typeof value === "boolean") {
          emailSettingsObj[key] = value;
        }
      });
      setNotificationSettings(prev => ({
        ...prev,
        email: emailSettingsObj
      }));
    }

    if (pushSettings) {
      const pushSettingsObj = {};
      Object.entries(pushSettings).forEach(([key, value]) => {
        if (typeof value === "boolean") {
          pushSettingsObj[key] = value;
        }
      });
      setNotificationSettings(prev => ({
        ...prev,
        push: pushSettingsObj
      }));
    }
  }, [tgSettings, emailSettings, pushSettings]);



  const handleTelegramSettingChange = (key, value) => {
    setNotificationSettings(prev => ({
      ...prev,
      telegram: {
        ...prev.telegram,
        [key]: value
      }
    }));

    if (Array.isArray(tgSettings)) {
      const newSettings = [...tgSettings];
      newSettings[key] = {
        ...newSettings[key],
        value: value
      };
      setTgSettings(newSettings);
    }
  };

  const handleEmailSettingChange = (key, value) => {
    setNotificationSettings(prev => ({
      ...prev,
      email: {
        ...prev.email,
        [key]: value
      }
    }));

    if (Array.isArray(emailSettings)) {
      const newSettings = [...emailSettings];
      newSettings[key] = {
        ...newSettings[key],
        value: value
      };
      setEmailSettings(newSettings);
    }
  };

  const handlePushSettingChange = (key, value) => {
    setNotificationSettings(prev => ({
      ...prev,
      push: {
        ...prev.push,
        [key]: value
      }
    }));

    if (Array.isArray(pushSettings)) {
      const newSettings = [...pushSettings];
      newSettings[key] = {
        ...newSettings[key],
        value: value
      };
      setPushSettings(newSettings);
    }
  };


  const [svgContent, setSvgContent] = useState('');

  const getQr = () => {
    return requestSvg(
      'panpartner:profile.ajax',
      'getTelegramQRCode',
      {},
      false,
      { responseType: 'text' }
    ).then(data => {
      setSvgContent(data);
    });
  };

  useEffect(() => {
    getQr();
  }, []);

  const [changePasswordModal, closeChangePasswordModal] = useModal(
    () => (
      <PanModal customClass="panmodal_change-password" title={'Изменить пароль'} closeModal={closeChangePasswordModal} >
        <ChangePassword redesign closeChangePasswordModal={closeChangePasswordModal} editPassword={editPassword} />
      </PanModal>
    ),
    [],
  );


  return (
    <section className="section section_view_white profile no-header-profile">
      <div className="wrapper">
        <div className="personal_content redesign create-company">
          <div className="profile__header">
            <div className="profile__title">

              <h3 className="h3">Личный профиль</h3>
            </div>
          </div>
          <div className="profile__grid">
            <div className="profile__grid-col profile__info">
              <form
                className="profile__form js-form-address"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="profile__main-settings">
                  <div className="create-company__top">
                    <div className="create-company__top-left">
                      <div className="create-company__block">
                        <p className="create-company__block-title">Основные</p>

                        <div className="profile__redesign-topset">


                          <div className="create-company__add">
                            <label
                              className="input input_type_form-files lk-form__logo"
                              htmlFor="lk-form-logo"
                            >
                              <input
                                className="input__control"
                                type="file"
                                id="lk-form-logo"
                                onChange={changeFile}
                              />
                              <div className="lk-form__logo-image">
                                <img src={logo} />
                              </div>
                              <div className="lk-form__logo-load link-hover">
                                Загрузить
                              </div>
                            </label>
                          </div>
                          <div className="profile__redesign-fullblock">
                            <div className="lk-form__fr lk-form__fr_auto">
                              <label
                                className="input input_type_form input_width_available"
                                htmlFor="cl-sec-name"
                              >
                                <input
                                  name="lastName"
                                  placeholder="Фамилия"
                                  className={
                                    "input__control" +
                                    (errors.lastName ? " input__error" : "")
                                  }
                                  id="cl-sec-name"
                                  ref={register({
                                    required: "Введите фамилию",
                                  })}
                                  autoComplete="off"
                                />
                              </label>
                            </div>
                            <div className="lk-form__fr lk-form__fr_auto">
                              <label
                                className="input input_type_form input_width_available"
                                htmlFor="cl-name"
                              >
                                <input
                                  name="name"
                                  placeholder="Имя"
                                  className={
                                    "input__control" +
                                    (errors.name ? " input__error" : "")
                                  }
                                  ref={register({
                                    required: "Введите имя",
                                  })}
                                  id="cl-name"
                                  autoComplete="off"
                                />
                              </label>
                            </div>
                            <div className="lk-form__fr lk-form__fr_auto">
                            <label
                              className="input input_type_form input_width_available"
                              htmlFor="cl-f-name"
                            >
                              <input
                                name="patronymic"
                                placeholder="Отчество"
                                className="input__control"
                                id="cl-f-name"
                                autoComplete="off"
                                ref={register}
                              />
                            </label>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="create-company__top-right">
                      {!!manager && <div className="create-company__block create-company__block_dark">
                        <p className="create-company__block-title">{isEmployee? "Ваш личный менеджер" : "Личный менеджер" }</p>


                        <div className="create-company__manager">
                          {manager.photo && (<img src={`${manager.photo.src}`} className="create-company__manager-img" alt="" />)}
                          <div className="create-company__manager-info">
                            <p className="create-company__manager-name">{manager.name} {manager.lastName}</p>
                            <div className="create-company__manager-seconodinfo">
                              <div>
                                <div><a href={`tel:${manager.phone}`} className="create-company__manager-phone link link_color_black">{manager.phone}</a></div>
                                <div><a href={`mailto:${manager.email}`} className="create-company__manager-email link link_color_black">{manager.email}</a></div>
                              </div>
                              <div className="create-company__manager-social">
                                <a target="_blank" href={`https://t.me/${manager.telegram}`}><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="white"/><path d="M22.2 9.02576L7.46685 13.1746C7.34133 13.2086 7.22935 13.2805 7.14618 13.3805C7.06302 13.4805 7.0127 13.6037 7.0021 13.7333C6.9915 13.8629 7.02113 13.9926 7.08695 14.1048C7.15277 14.217 7.25157 14.3061 7.3699 14.3601L14.1353 17.5605C14.2676 17.6221 14.3739 17.7285 14.4356 17.8608L17.6391 24.6293C17.6929 24.7477 17.7819 24.8466 17.8939 24.9125C18.0059 24.9785 18.1356 25.0084 18.2652 24.998C18.3948 24.9876 18.518 24.9376 18.6181 24.8546C18.7183 24.7717 18.7904 24.6599 18.8247 24.5345L22.9745 9.8003C23.0209 9.6417 23.0027 9.47116 22.9237 9.326C22.8447 9.18085 22.7114 9.07289 22.553 9.02576C22.4378 8.99141 22.3151 8.99141 22.2 9.02576V9.02576Z" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.3439 17.6563L17.9162 14.084" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round"/></svg></a>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>}

                      <div className="create-company__block create-company__block_dark">
                        <p className="create-company__block-title">Режим быстрого просмотра</p>
                        <Checkbox
                          id={'tradeIn'}
                          onChange={(e) => setSettings(prev => prev ?
                            { ...prev, isFastView: e.target.checked ? "1" : "0" } :
                            { isFastView: e.target.checked ? "1" : "0" })
                          }
                          checked={settings?.isFastView === "1"}
                          labelText={"Включает быстрый просмотр квартир во всплывающем окне"}
                        />
                      </div>
                    </div>


                  </div>
                </div>

                <div className="profile__main-settings" style={{paddingTop: 0}}>
                    <div className="create-company__block">
                      <p className="create-company__block-title">Основные</p>
                      <div className="profile__phone-settings">
                        <div className="lk-form__fr">
                          {fields.map((item, index) => (
                            <label
                              className="input input_type_form input_width_available"
                              htmlFor={`cl-phone${index}`}
                              key={`phone${index}`}
                            >

                              <Input
                                name={`phone[${index}]`}
                                className={
                                  "input__control" +
                                  (errors.phone && errors.phone[index]
                                    ? " input__error"
                                    : "")
                                }
                                type="text"
                                id={`cl-phone${item.id}`}
                                inputRef={register({
                                  required: "Введите телефон",
                                  validate: { inputTelRequired: phoneRequired },
                                })}
                                defaultValue={item.value}
                                key={item.id}
                                mask="+7 (999) 999-99-99"
                              />

                              {index === 0 ? (
                                <span className="input__alert info">
                              {isMobile ?
                                <Popup
                                  trigger={
                                    <svg className="icon icon_alert">
                                      <use xlinkHref="#alert"></use>
                                    </svg>
                                  }
                                >
                                  <p>
                                    <strong>Приоритетный номер</strong>
                                  </p>
                                  <br />
                                  <p style={{ lineHeight: '18px '}}>
                                    При заполненни формы обратной связи, этот
                                    номер будет автоматически подставляться в
                                    форму.
                                  </p>
                                </Popup> :
                                <svg className="icon icon_alert">
                                  <use xlinkHref="#alert"></use>
                                </svg>
                              }
                                  {!isMobile &&
                                    <div className="info__popup">
                                      <p>
                                        <strong>Приоритетный номер</strong>
                                      </p>
                                      <p>
                                        При заполненни формы обратной связи, этот
                                        номер будет автоматически подставляться в
                                        форму.
                                      </p>
                                    </div>
                                  }
                            </span>
                              ) : (
                                <button
                                  className="input__remove"
                                  onClick={(e) => {
                                    remove(index);
                                    e.preventDefault();
                                  }}
                                >
                                  <svg
                                    className="icon"
                                    width="7"
                                    height="8"
                                    viewBox="0 0 7 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.66667 1.3L0.333333 6.7"
                                      strokeLinecap="round"
                                    ></path>
                                    <path
                                      d="M0.333333 1.3L5.66667 6.7"
                                      strokeLinecap="round"
                                    ></path>
                                  </svg>
                                </button>
                              )}
                            </label>
                          ))}
                          <div className="lk-form__add-param">
                            <button
                              className="button button_type_add"
                              onClick={(e) => {
                                e.preventDefault();
                                append("");
                              }}
                            ></button>
                            <span>Добавить ещё телефон</span>
                          </div>
                        </div>
                        <div className="lk-form__fr">
                          {fieldsEmail.map((item, index) => (
                            <label
                              className="input input_type_form input_width_available"
                              htmlFor={`cl-email${index}`}
                              key={index}
                            >
                              {/*<span className="input__label">E-mail:</span>*/}
                              <input
                                name={`email[${index}]`}
                                className={
                                  "input__control" +
                                  (errors.email && errors.email[index]
                                    ? " input__error"
                                    : "")
                                }
                                type="email"
                                id={`cl-email${index}`}
                                autoComplete="off"
                                ref={register({
                                  required: "Введите e-mail",
                                  pattern: {
                                    value: validateMail,
                                    message: "Неправильный формат e-mail",
                                  },
                                })}
                              />
                              {index === 0 ? (
                                <span className="input__alert info">
                              {isMobile ?
                                <Popup
                                  trigger={
                                    <svg className="icon icon_alert">
                                      <use xlinkHref="#alert"></use>
                                    </svg>
                                  }
                                >
                                  <p>
                                    <strong>Приоритетный e-mail</strong>
                                  </p>
                                  <br />
                                  <p style={{ lineHeight: '18px '}}>
                                    При заполненни формы обратной связи, этот
                                    e-mail будет автоматически подставляться в
                                    форму.
                                  </p>
                                </Popup> :
                                <svg className="icon icon_alert">
                                  <use xlinkHref="#alert"></use>
                                </svg>
                              }
                                  {!isMobile &&
                                    <div className="info__popup">
                                      <p>
                                        <strong>Приоритетный e-mail</strong>
                                      </p>
                                      <p>
                                        При заполненни формы обратной связи, этот
                                        e-mail будет автоматически подставляться в
                                        форму.
                                      </p>
                                    </div>
                                  }
                            </span>
                              ) : (
                                <button
                                  className="input__remove"
                                  onClick={(e) => {
                                    removeEmail(index);
                                    e.preventDefault();
                                  }}
                                >
                                  <svg
                                    className="icon"
                                    width="7"
                                    height="8"
                                    viewBox="0 0 7 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M5.66667 1.3L0.333333 6.7"
                                      strokeLinecap="round"
                                    ></path>
                                    <path
                                      d="M0.333333 1.3L5.66667 6.7"
                                      strokeLinecap="round"
                                    ></path>
                                  </svg>
                                </button>
                              )}
                            </label>
                          ))}
                          <div className="lk-form__add-param">
                            <button
                              className="button button_type_add"
                              onClick={(e) => {
                                e.preventDefault();
                                appendEmail("");
                              }}
                            ></button>
                            <span>Добавить ещё e-mail</span>
                          </div>
                        </div>
                      </div>
                      <p className="create-company__block-title" style={{marginTop: 20}}>Соцсети</p>
                    <div className="lk-form__socials">
                      <div className="lk-form__fr">
                        <label
                          className="input input_type_form input_type_form_icon-left input_width_available"
                          htmlFor="lk-form-whatsapp"
                        >
                          <InputMask
                            name={`watsApp`}
                            id="lk-form-whatsapp"
                            className={"input__control"}
                            defaultValue={defaultValues.watsApp}
                            inputRef={register({})}
                            mask="+7 (999) 999-99-99"
                          ></InputMask>
                          <span className="input__icon" style={{backgroundColor: 'transparent'}}>
                            <svg className="icon icon_watch">
                              <use xlinkHref="#socials_whatsapp"></use>
                            </svg>
                          </span>
                        </label>
                      </div>
                      <div className="lk-form__fr">
                        <label
                          className="input input_type_form input_type_form_icon-left input_width_available"
                          htmlFor="lk-form-tg"
                        >
                          <input
                            name={`telegram`}
                            id="lk-form-tg"
                            className={
                              "input__control" +
                              (errors.telegram ? " input__error" : "")
                            }
                            defaultValue={defaultValues.telegram && defaultValues.telegram[0] !== '@' ? `@${defaultValues.telegram}` : defaultValues.telegram}
                            ref={register({
                              pattern: /@.+/
                            })}

                            onFocus={telegramInputFocus}
                            onChange={e => setTelegramValue(e)}
                            onBlur={e => telegramBlur(e)}
                          ></input>
                          <span className="input__icon" style={{backgroundColor: 'transparent'}}>
                            <svg className="icon icon_watch">
                              <use xlinkHref="#socials_tg"></use>
                            </svg>
                          </span>
                        </label>
                      </div>
                    </div>
                    </div>
                </div>

                <div className="profile__main-settings" style={{paddingTop: 0}}>
                <div className="create-company__block">
                  <p className="create-company__block-title">Описание</p>
                  <textarea
                    name="description"
                    className="cabinet-textarea"
                    ref={register({
                      required: false,
                    })}
                    placeholder="По желанию Вы можете указать описание компании"
                  ></textarea>


                </div>

                  {!isEmployee &&<div style={{display: "flex", gap: 20}}>
                    <div className="create-company__block" style={{marginTop: 20, width: '50%'}}>
                        <div className="cabinet-profile__tgtoogle-left">
                          <p><b>Уведомления в телеграм:</b></p>
                          {tgSettings && Array.isArray(tgSettings) && (
                            tgSettings.map((setting, index) => (
                              <div key={`tg-${setting.xmlId}-${index}`}>
                                <label className={classNames({switch: true, disabled: !setting?.active})}  htmlFor={`tg-${setting.xmlId}`}>
                                  <span className="switch__label">
                                    {setting.title}
                                  </span>
                                  <div className="switch__box">
                                    <input
                                      className="switch__control"
                                      type="checkbox"
                                      id={`tg-${setting.xmlId}`}
                                      onChange={(e) => handleTelegramSettingChange(index, e.target.checked)}
                                      checked={!!setting.value}
                                      disabled={!setting?.active}
                                    />
                                    <div className="switch__input" htmlFor={`tg-${setting.xmlId}`}/>
                                    <div className="switch__marker"/>
                                  </div>
                                </label>
                              </div>
                            ))
                          )}

                          <p><b>Уведомления на почту:</b></p>
                          {emailSettings && Array.isArray(emailSettings) && (
                            emailSettings.map((setting, index) => (
                              <div key={`email-${setting.xmlId}-${index}`}>
                                <label className={classNames({switch: true, disabled: !setting?.active})} htmlFor={`email-${setting.xmlId}`}>
                                  <span className="switch__label">
                                    {setting.title}
                                  </span>
                                  <div className="switch__box">
                                    <input
                                      className="switch__control"
                                      type="checkbox"
                                      id={`email-${setting.xmlId}`}
                                      onChange={(e) => handleEmailSettingChange(index, e.target.checked)}
                                      checked={!!setting.value}
                                      disabled={!setting?.active}
                                    />
                                    <div className="switch__input" htmlFor={`email-${setting.xmlId}`}/>
                                    <div className="switch__marker"/>
                                  </div>
                                </label>
                              </div>
                            ))
                          )}

                          <p><b>Push уведомления:</b></p>
                          {pushSettings && Array.isArray(pushSettings) && (
                            pushSettings.map((setting, index) => (
                              <div key={`push-${setting.xmlId}-${index}`}>
                                <label className={classNames({switch: true, disabled: !setting?.active})}  htmlFor={`push-${setting.xmlId}`}>
                                  <span className="switch__label">
                                    {setting.title}
                                  </span>
                                  <div className="switch__box">
                                    <input
                                      className="switch__control"
                                      type="checkbox"
                                      id={`push-${setting.xmlId}`}
                                      onChange={(e) => handlePushSettingChange(index, e.target.checked)}
                                      checked={!!setting.value}
                                                   disabled={!setting?.active}
                                    />
                                    <div className="switch__input" htmlFor={`push-${setting.xmlId}`}/>
                                    <div className="switch__marker"/>
                                  </div>
                                </label>
                              </div>
                            ))
                          )}





                        </div>
                    </div>
                    <div style={{width: '100%'}}>
                      <div className="create-company__block" style={{marginTop: 20, minHeight: 440, height: "max-content"}}>
                        <div className="cabinet-profile__tgtoogle-right">
                          <p><b>Оповещения в Телеграм</b></p>
                          <p style={{marginTop: 10}}>Добавьте бота в личный чат или группу в Telegram. </p>
                          <p style={{marginTop: 10, marginBottom: 5}}>Гибко настраивайте свои уведомления.</p>
                          <div dangerouslySetInnerHTML={{ __html: svgContent }} />
                        </div>
                      </div>
                      <div className="create-company__block" style={{marginTop: 20, height: "max-content"}}>
                        <div style={{marginBottom: 20}}>
                          <Link to={`/personal/profile/offers`}>
                            <Button
                              className="button button_view_default"
                              buttonType="primary_gray"
                              isFull={true}
                            >
                              Договор оферты
                            </Button>
                          </Link>
                        </div>

                        <div className="lk-form__submit">
                          <Button
                            className="button button_view_default"
                            buttonType="primary_gray"
                            isFull={true}
                            onClick={changePasswordModal}
                          >
                            Изменить пароль
                          </Button>
                        </div>

                      </div>
                    </div>

                  </div>}

                </div>


                {!isMobile &&
                  <div className="lk-form__footer">
                    {/*<div className="lk-form__reglament">*/}
                    {/*  <Link to={`/personal/profile/offers`}>*/}
                    {/*    <div className="input_type_upload-btn">*/}
                    {/*      Договор оферты*/}
                    {/*    </div>*/}
                    {/*  </Link>*/}
                    {/*</div>*/}
                    <div className="lk-form__btns">
                      <div className="lk-form__submit">
                        <SubmitButton
                          className="button button_view_default"
                          type="submit"
                          isLoading={isUpdating}
                        >
                          Сохранить изменения
                        </SubmitButton>
                      </div>
                    </div>
                  </div>
                }
              </form>
              {/*<div className="profile__main-settings profile__main-settings_password">*/}
              {/*  <div className="create-company__block create-company__block_dark">*/}
              {/*    <p className="create-company__block-title">Изменить пароль</p>*/}
              {/*    <ChangePassword editPassword={editPassword} />*/}
              {/*  </div>*/}
              {/*</div>*/}
              {isMobile &&
                <div className="lk-form__footer">
                  <div className="lk-form__reglament">
                    <Link to={`/personal/profile/offers`}>
                      <div className="input_type_upload-btn">
                        Договор оферты
                      </div>
                    </Link>
                  </div>
                  <div className="lk-form__btns">
                    <div className="lk-form__submit">
                      <button
                        className="button button_view_default"
                        type="submit"
                      >
                        Сохранить изменения
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
